import tokens from '@nimbus-ds/tokens/dist/js/tokens';
import { StylesConfig } from 'react-select';

export interface OptionType {
  value: string;
  label: string;
}

export const multiSelectColourStyles: StylesConfig<OptionType> = {
  control: (styles) => ({
    ...styles,
    minHeight: '34px',
    borderColor: tokens.color.light.neutral[80].value,
    borderRadius: tokens.shape.border.radius[2].value,
    fontWeight: tokens.font.weight.regular.value,
    fontSize: tokens.font.size.body.base.value,
    fontFamily: tokens.font.family.sans.value,
    cursor: 'pointer',
    ':hover': {
      borderColor: tokens.color.light.neutral[80].value,
    },
    ':focus': {
      borderColor: tokens.color.dark.primary['interactive-pressed'].value,
    },
    boxShadow: tokens.shadow.level[0].value,
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    fontSize: tokens.font.size.body.base.value,
    fontFamily: tokens.font.family.sans.value,
    backgroundColor:
      isSelected || isFocused
        ? tokens.color.light.neutral[99].value
        : undefined,
    color: tokens.color.light.neutral[20].value,
    cursor: 'pointer',
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: tokens.color.light.neutral[99].value,
    borderColor: tokens.color.light.neutral[80].value,
    borderRadius: tokens.shape.border.radius[1].value,
    borderStyle: 'solid',
    borderWidth: tokens.shape.border.width[1].value,
    color: tokens.color.light.neutral[0].value,
    cursor: 'pointer',
    height: tokens.line.height[6].value,
    alignItems: 'center',
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    fontFamily: tokens.font.family.sans.value,
    fontSize: tokens.font.size.body.caption.value,
    color: '#5d5d5d',
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    ':hover': {
      backgroundColor: tokens.color.light.neutral[90].original.value,
      borderColor: tokens.color.light.neutral[70].value,
    },
  }),
  noOptionsMessage: (styles) => ({
    ...styles,
    fontSize: tokens.font.size.body.base.value,
    fontFamily: tokens.font.family.sans.value,
  }),
  dropdownIndicator: (prevStyle) => ({
    ...prevStyle,
    height: '32px',
  }),
  indicatorSeparator: (prevStyle) => ({
    ...prevStyle,
    display: 'none',
  }),
  indicatorsContainer: (prevStyle) => ({
    ...prevStyle,
    alignItems: 'start',
  }),
  clearIndicator: (prevStyle) => ({
    ...prevStyle,
    height: '32px',
  }),
  valueContainer: (prevStyle) => ({
    ...prevStyle,
    padding: '0 4px',
  }),
  placeholder: (prevStyle) => ({
    ...prevStyle,
    margin: 0,
    padding: '0 4px',
    color: '#5d5d5d',
  }),
  input: (prevStyle) => ({
    ...prevStyle,
    padding: 0,
    margin: 0,
  }),
  groupHeading: (styles) => ({
    ...styles,
    fontSize: tokens.font.size.body.caption.value,
    fontFamily: tokens.font.family.sans.value,
    fontWeight: tokens.font.weight.medium.value,
    color: tokens.color.light.neutral[60].value,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
    padding: '8px 12px 6px 12px',
    margin: 0,
    backgroundColor: 'transparent',
    borderTop: `1px solid ${tokens.color.light.neutral[90].value}`,
    ':first-of-type': {
      borderTop: 'none',
      paddingTop: '4px',
    },
  }),
  group: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: '4px',
  }),
};

export const multiSelectColourStylesGrouped: StylesConfig<OptionType> = {
  ...multiSelectColourStyles,
  option: (styles, state) => ({
    ...multiSelectColourStyles.option?.(styles, state),
    paddingLeft: '24px',
  }),
};
